import { Observable } from 'rxjs';
import _ from 'lodash';
import { replace } from 'react-router-redux';

import FormsApi from 'entities/form/api';
import { showMessageAction, showErrorAction } from 'containers/Notification/actions';

import {
  initSuccessAction,
  initFailedAction,
  removeSuccessAction,
  removeFailedAction,
} from './actions';
import { INIT, REMOVE } from './constants';

const init = (action$, store) =>
  action$.ofType(INIT).mergeMap(({ id }) => {
    const actions = [];

    actions.push(FormsApi.fetch(id));

    if (actions.length === 0) {
      return Observable.of(initSuccessAction());
    }
    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)));
  });

const remove = (action$) =>
  action$.ofType(REMOVE).mergeMap(({ id, isSurvey }) =>
    FormsApi.delete(id)
      .mergeMap((resultingAction) => [
        resultingAction,
        replace(isSurvey ? '/surveys' : '/forms'),
        showMessageAction(isSurvey ? 'Survey removed!' : 'Form removed!'),
        removeSuccessAction(),
      ])
      .catch((e) => Observable.of(removeFailedAction(e), showErrorAction('Removal failed!')))
  );

export default [init, remove];
